import { ITip } from '../models/tips'
import { BaseUrl } from './base_url_enum'
import Api, { IApiResponse } from './index'

type IGetTipsResponse = {
  preventionTips: ITip[]
}

export const getTips = () => Api<IApiResponse<IGetTipsResponse>>('GET', 'prevention-tips', BaseUrl.Content)
